import { z } from 'zod';

const ArchivoCompraAgilDetalleUiSchema = z.object({
  nombre: z.string(),
  url_externa: z.string(),
  path_local: z.string()
});

const PreguntaRespuestaCompraAgilDetalleUiSchema = z.object({
  texto: z.string(),
  tipo: z.string(),
  orden: z.number()
});

export const CompraAgilDetalleUiSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  resumen: z.string().nullable(),
  resumen_llm: z.string().nullable(),
  resumen_archivos_llm: z.string().nullable(),
  codigo_externo: z.string(),
  codigo_estado: z.number(),
  estado_licitacion: z.string(), // Mapeado desde estado_compra_agil
  fecha_creacion: z.string().nullable(),
  fecha_cierre: z.string().nullable(),
  puntaje: z.number().nullable(),
  archivos: z.array(ArchivoCompraAgilDetalleUiSchema),
  preguntas_y_respuestas: z.array(PreguntaRespuestaCompraAgilDetalleUiSchema),
  estado_notificacion: z.string(),
  fecha_actualizacion: z.string().nullable(),
  monto_estimado: z.string().nullable(),
  moneda: z.string().nullable(),
  plazo_entrega: z.number().nullable(),
  resumen_procesado_filtro_palabras: z.boolean().nullable().optional(),
  archivos_procesados: z.boolean().nullable().optional(),
  resumen_procesado_filtro_llm: z.boolean().nullable().optional(),
  json_metadata: z.any().nullable().optional(),
  resumen_general: z.string().nullable().optional(),
  fecha_adjudicacion: z.string().nullable(),
  fecha_postulacion: z.string().nullable(),
  adjudicado: z.boolean().nullable(),
  postulado: z.boolean().nullable()
});

export type CompraAgilDetalleUi = z.infer<typeof CompraAgilDetalleUiSchema>; 